module.exports = __webpack_public_path__ + "static/media/time-icon-active.c2f51fe8.svg";